import SimpleBar from 'simplebar';
import $ from 'jquery'
import Utils from '@core/base/scripts/utils/utils';

export default class ThemesNavigation{
  constructor(){
    this.container=null;
    this.$wrapper=null;
    this.simpleBar=null;
  }

  init(container){
    this.container=container;
    //
    this.$wrapper=$('.themes-navigation__list-wrapper',this.container);
    this.$list=$('.themes-navigation__list');
    if(Utils.isTablet && !this.simpleBar){
      this.simpleBar=new SimpleBar(this.$wrapper[0], { autoHide: false });
    }else if(!Utils.isTablet && this.simpleBar){
      this.simpleBar.unMount();
      $('.simplebar-wrapper').remove();
      $('.simplebar-track').remove();
      this.$wrapper.removeAttr('data-simplebar');
      this.$wrapper.append(this.$list);
      this.simpleBar=null;
    }
  }

  onResize(){
    setTimeout(()=> {
      this.init();
    }, 0);
  }

  destroy(){
  }
}
